/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/* eslint-disable  */
import React, { lazy, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useCookies } from 'react-cookie';
import { useNavigate, useLocation } from 'react-router-dom';
import appNav from './appNav';
import Loader from '../components/Loader/Loader';
import { version } from '../constants/version';

const Main = lazy(() => import('../screens/Main'));

const PrivateRoute = ({ as: Component, ...props }) => {
  const [cookies] = useCookies();
  const navigate = useNavigate();
  const [auth, setAuth] = React.useState(false);
  const location = useLocation();

  const { pathname } = location;
  useEffect(() => {
    if (false) {
      navigate('../login');
      setAuth(false);
    } else {
      setAuth(true);
    }
  }, [cookies.token, navigate]);

  useEffect(() => {
    const versionFn = () => {
      // const appVersionFromBackend = Cookies.get('appVersion');
      // console.log(appVersionFromBackend, 5353);
      // const versionReloadCount = Cookies.get('versionReloadCount') || 0;
      // console.log(version, 5354, versionReloadCount);
      // if (version != appVersionFromBackend && versionReloadCount < 3) {
      //   console.log('version reload');
      //   Cookies.set('versionReloadCount', parseInt(versionReloadCount, 10) + 1, { expires: 0.01 }); // expires in 15 min
      //   window.location.reload(true);
      // }
      const appVersionFromBackend = Cookies.get('appVersion');
      const versionReloadCount = Cookies.get('versionReloadCount') || 0;
      console.log(version, 5354, versionReloadCount);
      if (version !== appVersionFromBackend) {
        if (versionReloadCount < 1) {
          Cookies.set('versionReloadCount', parseInt(versionReloadCount, 10) + 1, {
            expires: 0.01,
          }); // expires in 15 min
          navigator.serviceWorker.getRegistrations()
  .then(registrations => {
    registrations.forEach(registration => {
      registration.unregister()
    }) 
  })
          //window.location.reload(true);
        } else {
          // Reset the reload count if it's 3 or more
          Cookies.set('versionReloadCount', 0, { expires: 0.01 }); // expires in 15 min
        }
      } else {
        // Reset the reload count if the version matches
        Cookies.set('versionReloadCount', 0, { expires: 0.01 }); // expires in 15 min
      }
    };
    versionFn();
    console.log(pathname, 5355);
  }, [pathname]);

  return auth ? <Component {...props} /> : <Loader />;
};

const appRoutes = [
  {
    path: 'app',
    element: <PrivateRoute as={Main} />,
    children: appNav,
  },
];

export default appRoutes;
